import React, { useState, useEffect } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box, 
  CardMedia 
} from '@mui/material';
import Footer from '../navbar/Footer';
import moment from 'moment'; 

const bulletins = [

  {
    title: "Privations multidimensionnelles et pauvreté des enfants au Burundi, Rapport final",
    link: "/documents/enqueteMenages/Rapport_Final_complet-Pauvrete_EnfantMODA-2022.pdf",
    date: "2022-12-01",
    image: 'assets/covers/cover1.PNG', 
    description: "Au Burundi, la pauvreté infantile est plus aiguë en multidimensionnel (64%) qu'en monétaire (55,3%). 41,4% cumulent les deux pauvretés, avec des privations maximales en alimentation/assainissement et un écart prononcé urbain-rural.",
  },
  {
    title: "Rapport de l'enquête intégrée sur les conditions de vie des ménages au Burundi (EICVMB, 2019-2020) | Module: Emploi",
    link: "/documents/enqueteMenages/RAPPORT_EMPLOI-Final-2021.pdf",
    date: "2021-12-01",
    image: 'assets/covers/cover2.PNG', 
    description: "Malgré un faible chômage (1,1%), le Burundi fait face à un sous-emploi endémique (53,4%) et des revenus précaires (68,9% <1M FBU/an). Le travail des enfants persiste (4,7%), tandis que l'écart urbain-rural dans l'activité (59,8% vs 78,8%) révèle des déséquilibres structurels.",
  },
  {
    title: "Rapport de l’enquête intégrée sur les conditions de vie des ménages au Burundi (EICVMB, 2019-2020) | Module: Bien-être et accès aux services de base",
    link: "/documents/enqueteMenages/BIEN-ETRE-ET-ACCES-AUX-SERVICES-DE-BASE_2021-RAPPPORT-FINAL_Rev.19.08.2022.pdf",
    date: "2021-12-01",
    image: 'assets/covers/cover3.PNG', 
    description: "Le Burundi face à des défis structurels : population jeune (48% <15 ans), accès limité à l'électricité (9%), 72,7% des ménages en précarité alimentaire, malgré un réseau scolaire (87%) et sanitaire (56,1%) relativement développé.",
  },
  {
    title: "Rapport de l’enquête intégrée sur les conditions de vie des ménages au Burundi (EICVMB, 2019-2020) | Module: Profil et déterminants de la pauvreté au Burundi",
    link: "/documents/enqueteMenages/EICVMB_Rapport-final_Profil-et-determinants-de-la-pauvrete_2021.pdf",
    date: "2021-12-01",
    image: 'assets/covers/cover3.PNG', 
    description: "La pauvreté touche 51,4% des Burundais (plus en zones rurales), avec 66% des revenus consacrés à l'alimentation. Il faudrait 294 353 FBU/an/ménage pour atteindre le seuil de pauvreté.",
  },
  {
    title: "Rapport définitif de l’enquête intégrée sur les conditions de vie des ménages au Burundi (EICVMB, 2019-2020) | Module: Transferts d’argent aux ménages",
    link: "/documents/enqueteMenages/EICVMB_Rapport_Transferts-dargent-aux-menages_2021-VF-04-10-2022.pdf",
    date: "2021-12-01",
    image: 'assets/covers/cover2.PNG', 
    description: "Le Burundi enregistre un solde positif de transferts (128,1 vs 60,1 milliards FBU), avec 64,4% via des canaux formels (dont mobile). L'usage majoritairement consumériste (70,3%) appelle à optimiser leur impact économique.",
  },
  {
    title: "Rapport de l’enquête intégrée sur les conditions de vie des ménages au Burundi (EICVMB, 2019-2020) | Module: Agriculture, élevage et pêche",
    link: "/documents/enqueteMenages/EICVMB_Rapport_Agriculture_elevage-et-peche_VF_12.12.2022.pdf",
    date: "2021-12-01",
    image: 'assets/covers/cover3.PNG', 
    description: "L'agriculture, pilier de l'économie burundaise : 86% des ménages pratiquent l'agriculture (40% utilisent des engrais) et 69% élèvent du bétail, révélant un potentiel à optimiser par des politiques ciblées sur la productivité et la santé animale.",
  }
  ,
  {
  title: "Burundi : Profil et Déterminants de la Pauvreté (ECMVB 2013/2014)",
  link: "/documents/enqueteMenages/ECVMB-Profil-et-Determinants-de-la-pauvrete-Rapport-Final-ISTEEBU-def.pdf",
  date: "2015-05-01",
  image: "assets/covers/cover1.PNG",
  description: "En 2014, près de 65 % des Burundais vivaient sous le seuil de pauvreté, avec une forte prévalence en milieu rural. Le seuil de pauvreté annuel est estimé à 636 510 FBU par adulte, selon l’enquête ECMVB 2013/2014.",
}
];
function filterBulletins(bulletins, year) {
  if (year === null || year === 'Tous') {
    return bulletins;
  } else {
    return bulletins.filter(bulletin => bulletin.date.includes(year));
  }
}

function EnqueteMenage() {
  const [visibleCount, setVisibleCount] = useState(2);
  const [filteredBulletins, setFilteredBulletins] = useState([]);
  const [selectedYear, setSelectedYear] = useState('Tous');

  useEffect(() => {
    const sortedBulletins = [...bulletins].sort((a, b) => new Date(b.date) - new Date(a.date));
    setFilteredBulletins(filterBulletins(sortedBulletins, selectedYear));
  }, [selectedYear]);

  const uniqueYears = [...new Set(bulletins.map(bulletin => bulletin.date.split('-')[0]))].sort((a, b) => b - a);
  
  const handleShowMore = () => {
    setVisibleCount(prevCount => prevCount + 2);
  };

  const handleFilter = (year) => {
    setSelectedYear(year);
  };

  return (
    <div style={{ backgroundColor: '#f0f4f8', paddingBottom: '20px' }}>
      <NavigationBar />
      <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C', marginBottom: '20px' }}>
          Rapports des enquêtes ménages
        </Typography>
        <Typography variant="body1" align="left" gutterBottom style={{ marginBottom: '20px' }}>
          Cette page met à votre disposition une sélection des rapports d'enquête menés sur les conditions de vie des ménages burundais. Ces documents fournissent des analyses approfondies des défis socio-économiques auxquels sont confrontées les familles, ainsi que des recommandations pour améliorer leur bien-être. 
          <br /><br />
          En naviguant à travers ces rapports, vous découvrirez des informations précieuses sur la pauvreté, l'éducation, l'accès aux soins de santé et bien plus encore, afin de mieux comprendre le contexte de développement du Burundi et d'orienter les actions futures.
        </Typography>
        <Grid container spacing={1} style={{ marginTop: '20px' }}>
          <Grid item xs={12} sm={6} md={12}>
            <FormControl fullWidth style={{ marginLeft: '0px', width: '300px',marginBottom:'20px' }}>
              <InputLabel id="year-select-label">Sélectionnez une année de publication</InputLabel>
              <Select
                labelId="year-select-label"
                id="year-select"
                value={selectedYear}
                onChange={(e) => handleFilter(e.target.value)}
                label="Sélectionnez une année de publication"
                style={{ width: '100%' }}
              >
                <MenuItem value="Tous">Tous les rapports</MenuItem>
                {uniqueYears.map((year) => (
                  <MenuItem key={year} value={year}>{year}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={1} style={{ marginTop: '10px' }}>
        {filteredBulletins.slice(0, visibleCount).map((indice, index) => (
                        <Grid item xs={12} sm={12} key={index}>
                            <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                                <Box sx={{ display: 'flex' }}>
                                    <a
                                        href={indice.link}
                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <CardMedia
                                            component="img"
                                            sx={{ width: 91, height: 140, m: 2 }}
                                            image={indice.image}
                                            alt={indice.title}
                                        />
                                    </a>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                                        <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                                            <a
                                                href={indice.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ textDecoration: 'none', color: 'green' }} 
                                            >
                                                {<DownloadIcon />}{indice.title}
                                            </a>
                                        </Typography>
                                        <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                                            {indice.description}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary">
                                            Publié en {moment(indice.date).format('MMMM YYYY')}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
        {visibleCount < filteredBulletins.length && (
          <Button onClick={handleShowMore} style={{ marginTop: '20px', backgroundColor: '#388E3C', color: 'white' }}>
            Plus de rapports
          </Button>
        )}
      </Container>
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default EnqueteMenage;